import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { zhanden } from '@src/utils/zhanden'; 

const ViewDetails = ({ confirmData, confirmDataHandle, languages }) => {
    useEffect(() => {
        if (!confirmData.isClosePopup) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.position = '';
        }

    }, [confirmData]);

    return !confirmData.isClosePopup ? (
        <div className={styles.confirm}>
            <div className={styles.confirmBox}>
                <div className={styles.confirmTitle}>
                    <div dangerouslySetInnerHTML={{ __html: zhanden[languages].declaration.detailText }} />
                    <div className={styles.space_100} />
                </div>
                <div className={styles.confirmOperate}>
                    <div
                        className={styles.confirmYes}
                        onClick={() => {
                            confirmDataHandle({ isClickOk: false, isCheck: true, isClosePopup: true });
                        }}>
                        {zhanden[languages].declaration.disagreeText}
                    </div>
                    <div
                        className={styles.confirmCancel}
                        onClick={() => {
                            confirmDataHandle({ isClickOk: true, isCheck: false, isClosePopup: true });
                        }}>
                        {zhanden[languages].declaration.agreeText}
                    </div>
                </div>
                <div
                    className={styles.confirmClose}
                    onClick={() => {
                        confirmDataHandle({
                            ...confirmData,
                            isClosePopup: true
                        });
                    }}
                />
            </div>
        </div>
    ) : null;
};

ViewDetails.propTypes = {
    confirmData: PropTypes.object,
    confirmDataHandle: PropTypes.func,
    languages: PropTypes.string
};

export default errorBoundary(ViewDetails);
